"use client";
import React, { FC, useEffect, useState } from "react";
import Coins from "../assets/coins";
import People from "../assets/people";
import Shark from "../assets/shark";

import CoinsT from "../assets/coinsT";
import PeopleT from "../assets/peopleT";
import SharkT from "../assets/sharkT";

import CoinsM from "../assets/coinsM";
import PeopleM from "../assets/peopleM";
import SharkM from "../assets/sharkM";

type Props = {
	img: string;
	title: string;
	text: string;
	white?: boolean;
};

const PrizeItem: FC<Props> = ({ img, text, title, white }) => {
	const [isHovered, setIsHovered] = useState(false);

	const bg = white
		? "bg-white hover:bg-transparent"
		: " bg-transparent hover:bg-white";
	const textColor = white
		? "text-greenLight hover:text-white"
		: "text-white hover:text-greenLight";
	const transition = "transition-all duration-700";

	const [screenWidth, setScreenWidth] = useState(0);

	useEffect(() => {
		const handleResize = () => {
			setScreenWidth(window.innerWidth);
		};
		handleResize();
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleHover = () => {
		setIsHovered(!isHovered);
	};

	const image = () => {
		switch (img) {
			case "shark":
				return (
					<Shark
						fillHover={`${transition} max-desktop:hidden ${
							isHovered ? "fill-greenLight " : "fill-white "
						}`}
					/>
				);
				break;
			case "people":
				return (
					<People
						fillHover={`${transition} max-desktop:hidden ${
							isHovered ? "fill-white " : "fill-greenLight "
						}`}
					/>
				);
				break;
			case "coins":
				return (
					<Coins
						fillHover={`${transition} max-desktop:hidden  ${
							isHovered ? "fill-greenLight " : "fill-white "
						}`}
					/>
				);
				break;

			default:
				break;
		}
	};
	const imageT = () => {
		switch (img) {
			case "shark":
				return (
					<SharkT
						fillHover={`${transition} ${
							isHovered ? "fill-greenLight " : "fill-white "
						}`}
					/>
				);
				break;
			case "people":
				return (
					<PeopleT
						fillHover={`${transition} ${
							isHovered ? "fill-white " : "fill-greenLight"
						}`}
					/>
				);
				break;
			case "coins":
				return (
					<CoinsT
						fillHover={`${transition}  ${
							isHovered ? "fill-greenLight " : "fill-white "
						}`}
					/>
				);
				break;

			default:
				break;
		}
	};

	const imageM = () => {
		switch (img) {
			case "shark":
				return (
					<SharkM
						fillHover={`${transition} ${
							isHovered ? "fill-greenLight " : "fill-white "
						}`}
					/>
				);
				break;
			case "people":
				return (
					<PeopleM
						fillHover={`${transition} ${
							isHovered ? "fill-white " : "fill-greenLight"
						}`}
					/>
				);
				break;
			case "coins":
				return (
					<CoinsM
						fillHover={`${transition}  ${
							isHovered ? "fill-greenLight " : "fill-white "
						}`}
					/>
				);
				break;

			default:
				break;
		}
	};
	return (
		<div
			//@ts-ignore
			onMouseEnter={screenWidth >= 768 ? handleHover : null}
			//@ts-ignore
			onMouseLeave={screenWidth >= 768 ? handleHover : null}
			className={` w-full h-[297px] max-desktop:h-[169px] max-tablet:px-[8px] max-tablet:h-[200px] flex flex-col rounded-[15px] border-[2px] border-white ${bg} ${textColor}  transition-all duration-700 cursor-pointer items-center `}>
			<div
				className={`absolute max-desktop:hidden ${
					img === "coins" ? "mt-[26px]" : ""
				}`}>
				{image()}
			</div>
			<div
				className={`absolute hidden max-desktop:block max-tablet:hidden ${
					img === "coins" ? "mt-[18px]" : ""
				}`}>
				{imageT()}
			</div>
			<div
				className={`absolute hidden  max-tablet:block ${
					img === "coins" ? "mt-[25px]" : ""
				}
				${img === "shark" ? "mt-[22px]" : ""}
				${img === "people" ? "mt-[-4px]" : ""}`}>
				{imageM()}
			</div>

			<p className='text-[27px] mt-[156px] max-desktop:mt-[93px] max-tablet:mt-[114px] max-desktop:text-[15px] max-tablet:text-[18px] font-bold tracking-[1px] leading-[35px] max-desktop:leading-[19px] max-tablet:leading-[18px]'>
				{title}
			</p>
			<p className='text-[22px] mt-[8px] tracking-[1px] font-[500] leading-[22px] max-desktop:leading-[12px] max-tablet:leading-[15px] max-desktop:text-[12px] max-tablet:text-[14px] mx-[40px] max-desktop:mx-[10px] text-center '>
				{text}
			</p>
		</div>
	);
};

export default PrizeItem;
